<div id="footer">
  <div class="footer-content">
    <div style="max-width: 450px;width: 100%;">
      <img src="assets/images/homepage/fyes-logo-white.png" alt="">
    </div>
    <div class="content-lists">
        <div class="ul-list">
          <span class="title">{{ 'footer_col_what_we_do' | translate }}</span>
          <span class="item link" (click)="goTo('solution/home')">{{ 'footer_home_automation' | translate }}</span>
          <span class="item link" (click)="goTo('solution/hotel')">{{ 'footer_hotel_automation' | translate }}</span>
          <span class="item link" (click)="goTo('solution/workspace')">{{ 'footer_workspace_automation' | translate }}</span>
          <!-- Hidden until the catalogue images are sorted. The /equipment route,
               its components and the footer_equipment key all stay in place, so
               re-enabling is just uncommenting this line. -->
          <!-- <span class="item link" (click)="goTo('equipment')">{{ 'footer_equipment' | translate }}</span> -->
        </div>
        <div class="ul-list">
          <span class="title">{{ 'footer_col_company' | translate }}</span>
          <span class="item link" (click)="goTo('about-us')">{{ 'footer_about_us' | translate }}</span>
          <span class="item">{{ 'footer_careers' | translate }}</span>
          <span class="item link" (click)="goToSection('projects-section')">{{ 'footer_case_studies' | translate }}</span>
          <span class="item link" (click)="goTo('contact')">{{ 'footer_contact_us' | translate }}</span>
        </div>
    </div>
  </div>

  <div class="bottom-bar">
    <!-- The year is computed, not part of the string: baked into a translation it
         would silently go stale every January, in two files. -->
    <!-- Left untranslated on purpose. The year is still computed rather than
         hardcoded, so the notice cannot go stale in the markup. -->
    <span>© {{ currentYear }} FYES. All rights reserved</span>
    <div class="policies">
      <span class="link" (click)="goTo('terms-of-use')">{{ 'footer_terms' | translate }}</span>
    </div>
    <div class="social-icons">
      <a href="https://www.linkedin.com/company/fyes/posts/?feedView=all" target="_blank" rel="noopener noreferrer"
        [attr.aria-label]="'footer_social_linkedin' | translate">
        <i class="fa-brands fa-linkedin-in fa-2x"></i>
      </a>
      <a href="https://www.facebook.com/fyes.systems/" target="_blank" rel="noopener noreferrer"
        [attr.aria-label]="'footer_social_facebook' | translate">
        <i class="fa-brands fa-facebook-f fa-2x"></i>
      </a>
      <a href="https://www.instagram.com/fyes.gr/" target="_blank" rel="noopener noreferrer"
        [attr.aria-label]="'footer_social_instagram' | translate">
        <i class="fa-brands fa-instagram fa-2x"></i>
      </a>
    </div>
  </div>
</div>
